export enum ContractType {
  Permanent = 'PERMANENT',
  Fixed = 'FIXED',
  Temporary = 'TEMPORARY',
  Internship = 'INTERNSHIP',
  Sandwich = 'SANDWICH'
}
